module.exports = __webpack_public_path__ + "img/money-icon.602e30d6.png";